import { useSpring, config } from 'react-spring';

export function useScrollToElement(scrollbar?: any) {
    const hasWindow = typeof window !== 'undefined' ? true : false;
    let isStopped = false;

    const [, setScrollPos] = useSpring(() => ({
        immediate: false,
        y: hasWindow ? window.pageYOffset : 0,
        x: hasWindow ? window.pageXOffset : 0,
        onFrame: ({ x, y }: any) => {
            if (!isStopped) {
                hasWindow && window.scrollTo(x, y);
            }
        },
        onRest: () => {
            isStopped = false;
            hasWindow && window.removeEventListener('wheel', stopScrollOnWheel);
        },
        config: config.default,
    }));

    const smoothScrollbar = (node: any) => {
        scrollbar.scrollIntoView(node, {
            offsetTop: 40,
            offsetLeft: 0,
            onlyScrollIfNeeded: false,
        });
    };

    const scrollTo = (node: any) => {
        hasWindow && window.addEventListener('wheel', stopScrollOnWheel);

        const y =
            node && hasWindow
                ? node.getBoundingClientRect().top >= 0
                    ? node.getBoundingClientRect().top + window.pageYOffset
                    : window.pageYOffset + node.getBoundingClientRect().top
                : null;

        const x =
            node && hasWindow
                ? node.getBoundingClientRect().left >= 0
                    ? node.getBoundingClientRect().left + window.pageXOffset
                    : window.pageXOffset + node.getBoundingClientRect().top
                : null;

        if (scrollbar) {
            smoothScrollbar(node);
        } else {
            !isStopped &&
                setScrollPos({
                    y: y - 40,
                    x: x,
                });
        }
    };

    function stopScrollOnWheel() {
        isStopped = true;
        //stopScroll();
        hasWindow && window.removeEventListener('wheel', stopScrollOnWheel);
    }

    return { scrollTo };
}
